import dayjs from 'dayjs';

import { useShallowEqualSelector } from '@/hooks';
import { DEFAULT_DATE_FORMAT, DEFAULT_HOUR_FORMAT } from '@/utils/constants';

function useFormatDateTime() {
	const { dateFormat, hourFormat } = useShallowEqualSelector(
		({ profile }) => ({
			dateFormat: profile.user.dateFormat || DEFAULT_DATE_FORMAT,
			hourFormat: profile.user.hourFormat
		})
	);
	return value => {
		const timeFormat =
			hourFormat === DEFAULT_HOUR_FORMAT ? 'HH:mm' : 'hh:mm A';
		const fullFormat = `${dateFormat.toUpperCase()} ${timeFormat}`;

		return dayjs.unix(value).format(fullFormat);
	};
}

export default useFormatDateTime;
